<mat-chip-set>
   <mat-chip
      [matMenuTriggerFor]="manageFlightsMenu"
      [removable]="false"
   >
      <span class="mr-2">{{ 'intermediate_reports.manage_flights' | translate }}</span>
      <fa-icon [icon]="caretDown"></fa-icon>
   </mat-chip>
</mat-chip-set>

<mat-menu
   #manageFlightsMenu
   [overlapTrigger]="false"
   yPosition="below"
>
   <p class="py-2 px-2">{{ 'intermediate_reports.manage_flights_info' | translate }}</p>

   @for (flight of flights(); track flight.id) {
      <button
         (click)="toggleFlight(flight, $event)"
         mat-menu-item
      >
         <div class="flex gap-x-2 items-center">
            <mat-checkbox
               [checked]="selectedFlightIds().includes(flight.id)"
               color="primary"
            ></mat-checkbox>
            <div class="flex flex-col">
               <span class="mat-title-small mb-1!">{{ flight.name }}</span>
               <span class="mat-body-strong text-dimmed"
                  >{{ flight.start_date | customDate }} {{ 'general.until' | translate }} {{ flight.end_date | customDate }}</span
               >
            </div>
         </div>
      </button>
   }
</mat-menu>
